/**
 * Minimal MapLibre style for M0 — just the page background coloured by the active
 * palette, so the empty canvas already looks like the right colour family.
 *
 * M1 will extend this with the S-52 layer set (depth areas, contours, coastline,
 * soundings, buoyage, beacons, lights, wrecks, names) driven from the per-cell
 * GeoJSON the converter emits.
 */
import type { StyleSpecification } from 'maplibre-gl';
import type { Palette } from '@/store';
import { getPalette } from './palettes';

export function buildBaseStyle(palette: Palette): StyleSpecification {
  const p = getPalette(palette);
  return {
    version: 8,
    name: `ardent-${palette}`,
    // OUR OWN GLYPHS, OFF THE DEVICE. Every piece of text on the chart is drawn
    // from these: mark and waypoint names, route labels, EBL and VRM readouts,
    // AIS. They used to come from demotiles.maplibre.org, which is a DEMO server
    // on the open internet, so on a boat with no signal none of that text drew at
    // all, on an app whose whole point is working offline. And a demo server can
    // rate-limit or go away whenever it likes.
    //
    // Open Sans Regular and Bold, five ranges each (Latin-1, Latin Extended-A,
    // punctuation, arrows, maths), 372 KB the lot. A character outside those
    // ranges asks for a range we do not ship and simply does not draw, which is
    // where we already were with no signal. See public/fonts/glyphs.
    glyphs: '/fonts/glyphs/{fontstack}/{range}.pbf',
    sources: {},
    layers: [
      {
        id: 'background',
        type: 'background',
        paint: { 'background-color': p.DEPDW },
      },
    ],
  };
}
